module.exports = __webpack_public_path__ + "img/login_back_2.e6c29634.svg";